import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { AttachmentService } from '../services/index';

@Component({
  selector: 'mojo-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageUploadComponent implements OnInit, OnDestroy {
  @Output()
  uploadedPhoto: EventEmitter<Blob> = new EventEmitter();

  @Input()
  photoId: number;

  @Input()
  uploadText = 'Upload logo';

  @Input()
  uploadTextSecondLine: string;

  @Input()
  imageSize = '120px';
  @Input() disabled = false;

  imgURL: any;

  image$: Observable<string>;

  private url: string;

  constructor(private attachmentService: AttachmentService, private sanitizer: DomSanitizer) {}

  ngOnDestroy() {
    return !!this.url && URL.revokeObjectURL(this.url);
  }

  ngOnInit() {
    this.image$ = !!this.photoId && this.getUrl$(this.photoId);
  }

  preview(files) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/(png|jpg|jpeg)/) === null) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (event) => {
      this.imgURL = reader.result;
      this.uploadedPhoto.emit(files[0]);
    };
  }

  getImage(url: string) {
    return this.sanitizer.bypassSecurityTrustStyle(`url(${url})`);
  }

  private getUrl$(id: number): Observable<string> {
    return this.attachmentService.download({ id }).pipe(
      map((blob: Blob) => URL.createObjectURL(blob)),
      map((url: string) => this.sanitizer.bypassSecurityTrustStyle(`url('${url}')`)),
      tap((url: string) => (this.url = url)),
    );
  }
}
